import styled from 'styled-components'

export const StyledEppContainer = styled.div`
  display: flex;
  padding: 8px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  border-radius: 4px;
  border: 1px solid var(--card-gray-with-outline-outline, #D4D4D6);
  background: var(--neutral-white-ffffff, #FFF);

  @media (max-width: 669px) {
    &.desktop-mode {
      display: none;
    }
  }

  @media (min-width: 670px) {
    &.mobile-mode {
      display: none;
    }
  }
`
export const StyledEppInnerContainer = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  display: flex;
`
export const StyledEppRightContainer = styled.div`
  width: 40.44px;
  height: 32px;
  position: relative
`
export const StyledEppDivX = styled.div`
  width: 32px;
  height: 25.32px;
  left: 0px;
  top: 0.01px;
  position: absolute;
  background-size: contain;
  background-image: url("https://cld.partsimg.com/image/upload/d_noimage.jpg,c_pad,f_auto,q_auto:best,dpr_auto/carparts/shipping-protection/extend_logo_light.png")
`
export const StyledEppLeftContainer = styled.div`
  flex: 1 1 0;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 2px;
  display: flex
`
export const StyledEppExtendTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const StyledEppExtendText = styled.div`
  color: #282832;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 23.10px;
  word-wrap: break-word;
`

export const StyledEppExtendPlan = styled.div`
  align-self: stretch;
  color: #282832;
  font-size: 12px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 23.10px;
  word-wrap: break-word
`
export const StyledEppSubtext = styled.div`
  align-self: stretch;
  color: #282832;
  font-size: 12px;
  font-family: Roboto;
  font-weight: 400;
  line-height: 19.80px;
  word-wrap: break-word
`
